import { HashtagString } from "../../../../../stores/useHashState";

export const priceMatchDialogHash: HashtagString = "#price-match-";

export const getPriceMatchDilalogLink = (lineItemId: string): HashtagString =>
  `${priceMatchDialogHash}${lineItemId}`;
